"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadCaptchaConfig = loadCaptchaConfig;
exports.queryLoginPageDetail = queryLoginPageDetail;
exports.saveCaptchaConfig = saveCaptchaConfig;
exports.updateLoginPageSettings = updateLoginPageSettings;
var _request = _interopRequireDefault(require("@/utils/request"));
function updateLoginPageSettings(data) {
  return (0, _request.default)({
    url: '/portal/system/tenant/updateLoginPageSettings',
    method: 'post',
    data: data
  });
}
function queryLoginPageDetail(params) {
  return (0, _request.default)({
    url: '/portal/system/tenant/queryLoginPageDetail',
    method: 'get',
    params: params
  });
}
function loadCaptchaConfig(params) {
  return (0, _request.default)({
    url: '/portal/system/tenant/loadCaptchaConfig',
    method: 'get',
    params: params
  });
}
function saveCaptchaConfig(data) {
  return (0, _request.default)({
    url: '/portal/system/tenant/saveCaptchaConfig',
    method: 'post',
    data: data
  });
}